/* Loaded synchronously in the head only for full storefront browsing pages.
   No fetch interception, product-resource redirect or purchase-form changes. */
(() => {
  const homeUrl = document.currentScript?.dataset.homeUrl;
  if (!homeUrl || window.Shopify?.designMode || window.Shopify?.visualPreviewMode) return;
  const destination = new URL(homeUrl, location.origin);
  if (destination.origin !== location.origin || destination.pathname === location.pathname) return;
  const attribution = new URLSearchParams(location.search);
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid']) {
    const value = attribution.get(key);
    if (value) destination.searchParams.set(key, value);
  }
  // Drop variant, option_values, search/filter and arbitrary routing parameters.
  window.location.replace(destination.href);
})();
